import React from "react";

import style from "../../assets/css/components/Chart/Chart.module.css";
import tinycolor from "tinycolor2";
import ReactApexChart from "react-apexcharts";

function PositionTeam({ teamColor, data }) {
  const series = [
    {
      name: "Posición",
      data,
    },
  ];

  const options = {
    chart: {
      type: "area",
      foreColor: "#848486",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    // colors: ["#00dd80"],
    colors: [
      tinycolor.readability("#17171d", teamColor) <= 2
        ? tinycolor
            .mostReadable("#17171d", ["#00dd80", teamColor])
            .toHexString()
        : teamColor,
    ],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      colors: "#17171d",
      type: "solid",
    },
    markers: {
      colors: ["#17171d"],
      strokeColor: [
        tinycolor.readability("#17171d", teamColor) <= 2
          ? tinycolor
              .mostReadable("#17171d", ["#00dd80", teamColor])
              .toHexString()
          : teamColor,
      ],
      strokeWidth: 3,
    },
    xaxis: {
      type: "category",
      categories: [
        "J1",
        "J2",
        "J3",
        "J4",
        "J5",
        "J6",
        "J7",
        "J8",
        "J9",
        "J10",
        "J11",
        "J12",
        "J13",
        "J14",
        "J15",
        "J16",
        "J17",
        "J18",
        "J19",
        "J20",
        "J21",
        "J22",
        "J23",
        "J24",
        "J25",
        "J26",
      ],
      labels: {
        show: true,
      },
      axisBorder: {
        color: "#6841f8",
        show: false,
      },
      axisTicks: {
        show: false,
        color: "#6841f8",
      },
    },
    yaxis: {
      show: false,
      reversed: true,
    },
    tooltip: {
      theme: "dark",
      enabled: true,
      x: {
        show: true,
        formatter: undefined,
      },
      y: {
        formatter: function (value) {
          return value;
        },
      },
    },
  };

  return (
    <>
      <ReactApexChart
        className={style.chart}
        options={options}
        series={series}
        type="area"
        width={"100%"}
        height={"100%"}
      />
    </>
  );
}

export default PositionTeam;
